import React from "react";
import { Link, useNavigate } from "react-router-dom";

import {
  FaInstagram,
  FaWhatsapp,
  FaArrowUp,
  FaHeart,
  FaShoppingBag,
  FaBullhorn,
  FaUsers,
  FaChartLine,
  FaShieldAlt,
  FaChevronRight,
} from "react-icons/fa";

const Footer = () => {
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const goToAllProducts = () => {
    navigate("/");

    setTimeout(() => {
      const section = document.getElementById(
        "all-productsssssssssssss"
      );

      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 250);
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="
        relative
        mt-16
        overflow-hidden

        bg-white
        text-gray-900

        border-t
        border-gray-200

        dark:bg-[#080a12]
        dark:text-white
        dark:border-white/[0.06]

        transition-colors
        duration-300
      "
    >
      {/* =====================================================
          DECORATIVE BACKGROUND
      ===================================================== */}

      <div
        className="
          pointer-events-none
          absolute
          -top-40
          -left-40
          w-[420px]
          h-[420px]
          rounded-full

          bg-indigo-500/5
          blur-3xl

          dark:bg-indigo-600/10
        "
      />

      <div
        className="
          pointer-events-none
          absolute
          -bottom-40
          -right-40
          w-[420px]
          h-[420px]
          rounded-full

          bg-violet-500/5
          blur-3xl

          dark:bg-violet-600/10
        "
      />

      {/* =====================================================
          MAIN CONTAINER
      ===================================================== */}

      <div
        className="
          relative
          max-w-[1600px]
          mx-auto

          px-5
          sm:px-8
          lg:px-10

          pt-14
          pb-10
        "
      >
        {/* =================================================
            MAIN GRID
        ================================================= */}

        <div
          className="
            grid
            grid-cols-1
            sm:grid-cols-2
            lg:grid-cols-[1.5fr_1fr_1fr_1.2fr]

            gap-10
            lg:gap-14
          "
        >
          {/* =================================================
              BRAND
          ================================================= */}

          <div>
            <Link
              to="/"
              onClick={scrollToTop}
              className="
                inline-flex
                items-center
                gap-3
                group
              "
            >
              <div
                className="
                  w-12
                  h-12
                  rounded-2xl

                  flex
                  items-center
                  justify-center

                  bg-gradient-to-br
                  from-indigo-500
                  via-violet-600
                  to-fuchsia-600

                  shadow-lg
                  shadow-indigo-500/20

                  transition-all
                  duration-300

                  group-hover:scale-105
                  group-hover:rotate-1
                "
              >
                <FaChartLine
                  size={19}
                  className="text-white"
                />
              </div>

              <div>
                <div
                  className="
                    text-2xl
                    font-black
                    tracking-tight

                    text-gray-900
                    dark:text-white
                  "
                >
                  ARTIM
                </div>

                <div
                  className="
                    -mt-1
                    text-[9px]
                    font-bold
                    uppercase
                    tracking-[0.28em]

                    text-indigo-600
                    dark:text-indigo-400
                  "
                >
                  Marketplace
                </div>
              </div>
            </Link>

            <p
              className="
                mt-5
                max-w-[380px]

                text-sm
                leading-7

                text-gray-600
                dark:text-gray-400
              "
            >
              ARTIM — elan yerləşdir, məhsulunu sat,
              istədiyin məhsulu tap və alış-veriş et.
            </p>

            <p
              className="
                mt-3
                max-w-[380px]

                text-sm
                leading-7

                text-gray-500
                dark:text-gray-500
              "
            >
              Dəvət etdiyin istifadəçilərdən qazanc əldə et,
              artan gəlir sistemindən yararlan və ARTIM
              platformasına qoşul.
            </p>

            {/* =================================================
                SOCIAL
            ================================================= */}

            <div className="mt-6 flex items-center gap-3">
              {/* INSTAGRAM */}

              <a
                href="https://instagram.com/akberofh"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="
                  w-11
                  h-11
                  rounded-2xl

                  flex
                  items-center
                  justify-center

                  bg-gray-100
                  border
                  border-gray-200

                  text-gray-500

                  hover:bg-pink-500
                  hover:border-pink-500
                  hover:text-white

                  dark:bg-white/[0.05]
                  dark:border-white/[0.08]
                  dark:text-gray-400

                  dark:hover:bg-pink-500
                  dark:hover:border-pink-500
                  dark:hover:text-white

                  transition-all
                  duration-300

                  hover:-translate-y-1
                "
              >
                <FaInstagram size={18} />
              </a>

              {/* WHATSAPP */}

              <a
                href="https://wa.me/994515983550"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                className="
                  w-11
                  h-11
                  rounded-2xl

                  flex
                  items-center
                  justify-center

                  bg-gray-100
                  border
                  border-gray-200

                  text-gray-500

                  hover:bg-green-500
                  hover:border-green-500
                  hover:text-white

                  dark:bg-white/[0.05]
                  dark:border-white/[0.08]
                  dark:text-gray-400

                  dark:hover:bg-green-500
                  dark:hover:border-green-500
                  dark:hover:text-white

                  transition-all
                  duration-300

                  hover:-translate-y-1
                "
              >
                <FaWhatsapp size={19} />
              </a>
            </div>
          </div>

          {/* =================================================
              SAYT
          ================================================= */}

          <div>
            <h3
              className="
                text-sm
                font-bold

                text-gray-900
                dark:text-white
              "
            >
              ARTIM
            </h3>

            <div
              className="
                mt-2
                w-8
                h-1
                rounded-full

                bg-indigo-500
              "
            />

            <div className="mt-5 space-y-3">
              {/* ANA SƏHİFƏ */}

              <Link
                to="/"
                onClick={scrollToTop}
                className="
                  group
                  flex
                  items-center
                  gap-2

                  text-sm

                  text-gray-500
                  hover:text-indigo-600

                  dark:text-gray-400
                  dark:hover:text-white

                  transition
                "
              >
                <FaChevronRight
                  size={9}
                  className="
                    text-indigo-500
                    transition
                    group-hover:translate-x-1
                  "
                />

                Ana səhifə
              </Link>

              {/* MƏHSULLAR */}

              <button
                type="button"
                onClick={goToAllProducts}
                className="
                  group
                  flex
                  items-center
                  gap-2

                  text-sm

                  text-gray-500
                  hover:text-indigo-600

                  dark:text-gray-400
                  dark:hover:text-white

                  transition
                "
              >
                <FaChevronRight
                  size={9}
                  className="
                    text-indigo-500
                    transition
                    group-hover:translate-x-1
                  "
                />

                Məhsullar
              </button>

              {/* HAQQIMIZDA */}

              <Link
                to="/about"
                className="
                  group
                  flex
                  items-center
                  gap-2

                  text-sm

                  text-gray-500
                  hover:text-indigo-600

                  dark:text-gray-400
                  dark:hover:text-white

                  transition
                "
              >
                <FaChevronRight
                  size={9}
                  className="
                    text-indigo-500
                    transition
                    group-hover:translate-x-1
                  "
                />

                Haqqımızda
              </Link>

              {/* ƏLAQƏ */}

              <Link
                to="/contact"
                className="
                  group
                  flex
                  items-center
                  gap-2

                  text-sm

                  text-gray-500
                  hover:text-indigo-600

                  dark:text-gray-400
                  dark:hover:text-white

                  transition
                "
              >
                <FaChevronRight
                  size={9}
                  className="
                    text-indigo-500
                    transition
                    group-hover:translate-x-1
                  "
                />

                Əlaqə
              </Link>
            </div>
          </div>

          {/* =================================================
              PLATFORM
          ================================================= */}

          <div>
            <h3
              className="
                text-sm
                font-bold

                text-gray-900
                dark:text-white
              "
            >
              Platforma
            </h3>

            <div
              className="
                mt-2
                w-8
                h-1
                rounded-full

                bg-violet-500
              "
            />

            <div className="mt-5 space-y-4">
              {/* ELAN YERLƏŞDİR */}

              <button
                type="button"
                onClick={() => navigate("/addPagenation")}
                className="
                  w-full

                  flex
                  items-start
                  gap-3

                  text-left
                  group
                "
              >
                <div
                  className="
                    w-9
                    h-9
                    shrink-0
                    rounded-xl

                    flex
                    items-center
                    justify-center

                    bg-indigo-500/10
                    text-indigo-500

                    dark:bg-indigo-500/10
                    dark:text-indigo-400

                    transition

                    group-hover:bg-indigo-500
                    group-hover:text-white
                  "
                >
                  <FaBullhorn size={14} />
                </div>

                <div>
                  <div
                    className="
                      text-sm
                      font-semibold

                      text-gray-800
                      dark:text-white
                    "
                  >
                    Elan yerləşdir
                  </div>

                  <div
                    className="
                      mt-0.5
                      text-xs
                      leading-5

                      text-gray-500
                      dark:text-gray-500
                    "
                  >
                    Məhsulunu elan yerləşdirərək satışa çıxar.
                  </div>
                </div>
              </button>

              {/* ALIŞ-VERİŞ */}

              <button
                type="button"
                onClick={goToAllProducts}
                className="
                  w-full

                  flex
                  items-start
                  gap-3

                  text-left
                  group
                "
              >
                <div
                  className="
                    w-9
                    h-9
                    shrink-0
                    rounded-xl

                    flex
                    items-center
                    justify-center

                    bg-emerald-500/10
                    text-emerald-500

                    dark:bg-emerald-500/10
                    dark:text-emerald-400

                    transition

                    group-hover:bg-emerald-500
                    group-hover:text-white
                  "
                >
                  <FaShoppingBag size={14} />
                </div>

                <div>
                  <div
                    className="
                      text-sm
                      font-semibold

                      text-gray-800
                      dark:text-white
                    "
                  >
                    Alış-veriş et
                  </div>

                  <div
                    className="
                      mt-0.5
                      text-xs
                      leading-5

                      text-gray-500
                      dark:text-gray-500
                    "
                  >
                    Elanlar arasında istədiyini tap.
                  </div>
                </div>
              </button>

              {/* DƏVƏT ET */}

              <button
                type="button"
                onClick={() => navigate("/profile")}
                className="
                  w-full

                  flex
                  items-start
                  gap-3

                  text-left
                  group
                "
              >
                <div
                  className="
                    w-9
                    h-9
                    shrink-0
                    rounded-xl

                    flex
                    items-center
                    justify-center

                    bg-violet-500/10
                    text-violet-500

                    dark:bg-violet-500/10
                    dark:text-violet-400

                    transition

                    group-hover:bg-violet-500
                    group-hover:text-white
                  "
                >
                  <FaUsers size={14} />
                </div>

                <div>
                  <div
                    className="
                      text-sm
                      font-semibold

                      text-gray-800
                      dark:text-white
                    "
                  >
                    Dəvət et və qazan
                  </div>

                  <div
                    className="
                      mt-0.5
                      text-xs
                      leading-5

                      text-gray-500
                      dark:text-gray-500
                    "
                  >
                    Dəvət etdiklərindən qazanc əldə et.
                  </div>
                </div>
              </button>
            </div>
          </div>

          {/* =================================================
              CONTACT
          ================================================= */}

          <div>
            <h3
              className="
                text-sm
                font-bold

                text-gray-900
                dark:text-white
              "
            >
              Bizimlə əlaqə
            </h3>

            <div
              className="
                mt-2
                w-8
                h-1
                rounded-full

                bg-fuchsia-500
              "
            />

            {/* WHATSAPP */}

            <a
              href="https://wa.me/994515983550"
              target="_blank"
              rel="noopener noreferrer"
              className="
                mt-5
                flex
                items-center
                gap-3

                group
              "
            >
              <div
                className="
                  w-11
                  h-11
                  rounded-2xl

                  flex
                  items-center
                  justify-center

                  bg-green-500/10
                  text-green-500

                  dark:bg-green-500/10
                  dark:text-green-400

                  transition

                  group-hover:bg-green-500
                  group-hover:text-white
                "
              >
                <FaWhatsapp size={19} />
              </div>

              <div>
                <div
                  className="
                    text-[10px]
                    uppercase
                    tracking-wider

                    text-gray-400
                    dark:text-gray-500
                  "
                >
                  WhatsApp
                </div>

                <div
                  className="
                    mt-0.5
                    text-sm
                    font-semibold

                    text-gray-800
                    dark:text-gray-200
                  "
                >
                  051 598 35 50
                </div>
              </div>
            </a>

            {/* INSTAGRAM */}

            <a
              href="https://instagram.com/akberofh"
              target="_blank"
              rel="noopener noreferrer"
              className="
                mt-4
                flex
                items-center
                gap-3

                group
              "
            >
              <div
                className="
                  w-11
                  h-11
                  rounded-2xl

                  flex
                  items-center
                  justify-center

                  bg-pink-500/10
                  text-pink-500

                  dark:bg-pink-500/10
                  dark:text-pink-400

                  transition

                  group-hover:bg-pink-500
                  group-hover:text-white
                "
              >
                <FaInstagram size={18} />
              </div>

              <div>
                <div
                  className="
                    text-[10px]
                    uppercase
                    tracking-wider

                    text-gray-400
                    dark:text-gray-500
                  "
                >
                  Instagram
                </div>

                <div
                  className="
                    mt-0.5
                    text-sm
                    font-semibold

                    text-gray-800
                    dark:text-gray-200
                  "
                >
                  @akberofh
                </div>
              </div>
            </a>

            {/* TRUST BOX */}

            <div
              className="
                mt-6
                p-4

                rounded-2xl

                bg-gray-50
                border
                border-gray-200

                dark:bg-white/[0.04]
                dark:border-white/[0.07]
              "
            >
              <div className="flex items-center gap-3">
                <div
                  className="
                    w-9
                    h-9
                    rounded-xl

                    flex
                    items-center
                    justify-center

                    bg-emerald-500/10
                    text-emerald-500

                    dark:text-emerald-400
                  "
                >
                  <FaShieldAlt size={14} />
                </div>

                <div>
                  <div
                    className="
                      text-xs
                      font-bold

                      text-gray-800
                      dark:text-gray-200
                    "
                  >
                    ARTIM platforması
                  </div>

                  <div
                    className="
                      mt-0.5
                      text-[10px]

                      text-gray-500
                    "
                  >
                    Alış-veriş və elan platforması
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* =================================================
            FEATURE STRIP
        ================================================= */}

        <div
          className="
            mt-12
            pt-8

            border-t

            border-gray-200
            dark:border-white/[0.07]

            grid
            grid-cols-1
            sm:grid-cols-3

            gap-4
          "
        >
          {/* ELAN */}

          <button
            type="button"
            onClick={() => navigate("/addPagenation")}
            className="
              flex
              items-center
              gap-3
              p-4

              rounded-2xl

              text-left

              bg-gray-50
              border
              border-gray-100

              hover:border-indigo-200
              hover:bg-indigo-50

              dark:bg-white/[0.025]
              dark:border-transparent
              dark:hover:bg-white/[0.05]
              dark:hover:border-white/[0.06]

              transition-all
              duration-300
            "
          >
            <FaBullhorn className="text-indigo-500 dark:text-indigo-400" />

            <div>
              <div
                className="
                  text-xs
                  font-bold

                  text-gray-800
                  dark:text-white
                "
              >
                Elanını yerləşdir
              </div>

              <div
                className="
                  text-[10px]
                  text-gray-500
                "
              >
                Satışa başla
              </div>
            </div>
          </button>

          {/* DƏVƏT */}

          <button
            type="button"
            onClick={() => navigate("/profile")}
            className="
              flex
              items-center
              gap-3
              p-4

              rounded-2xl

              text-left

              bg-gray-50
              border
              border-gray-100

              hover:border-violet-200
              hover:bg-violet-50

              dark:bg-white/[0.025]
              dark:border-transparent
              dark:hover:bg-white/[0.05]
              dark:hover:border-white/[0.06]

              transition-all
              duration-300
            "
          >
            <FaUsers className="text-violet-500 dark:text-violet-400" />

            <div>
              <div
                className="
                  text-xs
                  font-bold

                  text-gray-800
                  dark:text-white
                "
              >
                Dəvət et
              </div>

              <div
                className="
                  text-[10px]
                  text-gray-500
                "
              >
                Qazancını artır
              </div>
            </div>
          </button>

          {/* FAVORİ */}

          <div
            className="
              flex
              items-center
              gap-3
              p-4

              rounded-2xl

              bg-gray-50
              border
              border-gray-100

              dark:bg-white/[0.025]
              dark:border-transparent
            "
          >
            <FaHeart className="text-rose-500 dark:text-rose-400" />

            <div>
              <div
                className="
                  text-xs
                  font-bold

                  text-gray-800
                  dark:text-white
                "
              >
                Bəyəndiklərini saxla
              </div>

              <div
                className="
                  text-[10px]
                  text-gray-500
                "
              >
                Favorilərinə əlavə et
              </div>
            </div>
          </div>
        </div>

        {/* =================================================
            BOTTOM
        ================================================= */}

        <div
          className="
            mt-8
            pt-6

            border-t

            border-gray-200
            dark:border-white/[0.07]

            flex
            flex-col
            md:flex-row

            items-center
            justify-between

            gap-4
          "
        >
          {/* COPYRIGHT */}

          <div
            className="
              text-xs
              text-gray-500
              text-center
              md:text-left
            "
          >
            © {currentYear} ARTIM.shop

            <span className="mx-2 text-gray-300 dark:text-gray-700">
              •
            </span>

            Bütün hüquqlar qorunur.
          </div>

          {/* LINKS */}

          <div
            className="
              flex
              items-center
              gap-4

              text-xs
              text-gray-500
            "
          >
            <Link
              to="/about"
              className="
                hover:text-indigo-600
                dark:hover:text-white

                transition
              "
            >
              Haqqımızda
            </Link>

            <span className="text-gray-300 dark:text-gray-700">
              •
            </span>

            <Link
              to="/contact"
              className="
                hover:text-indigo-600
                dark:hover:text-white

                transition
              "
            >
              Əlaqə
            </Link>
          </div>

          {/* BACK TO TOP */}

          <button
            type="button"
            onClick={scrollToTop}
            className="
              w-10
              h-10
              rounded-xl

              flex
              items-center
              justify-center

              bg-gray-100
              border
              border-gray-200

              text-gray-500

              hover:bg-indigo-600
              hover:text-white
              hover:border-indigo-600

              dark:bg-white/[0.06]
              dark:border-white/[0.08]
              dark:text-gray-400

              dark:hover:bg-indigo-600
              dark:hover:text-white
              dark:hover:border-indigo-600

              transition-all
              duration-300
            "
            aria-label="Yuxarı qalx"
          >
            <FaArrowUp size={13} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;